import {useTranslation} from "@Translation/hooks/useTranslation";
import {multiModalTranslationKey} from "@SearchResults/features/staticContent/constants/translationKeys";
import TitleAndContent from "@SearchResults/features/staticContent/components/TitleAndContent";
import {TransportTypesType} from "@SearchResults/types/TransportTypes.type";
import getTranslationFromTransportType
    from "@SearchResults/features/staticContent/functions/getTranslationFromTransportType";
import {RoutesOrganizedByTransportTypeType} from "@SearchResults/types/RoutesOrganizedByTransportType.type";
import getMinMaxPriceForType from "@SearchResults/features/staticContent/functions/getMinMaxPriceForType";

interface HowManyTripsContentProps {
    departure: string,
    destination: string,
    singleRoutes: RoutesOrganizedByTransportTypeType,
    totalNumberOfTrips: number,
    cheapestVehClass: TransportTypesType,
    priciestVehClass: TransportTypesType,
}

function HowManyTripsContent(props: HowManyTripsContentProps) {
    const {
        departure,
        destination,
        singleRoutes,
        totalNumberOfTrips,
        cheapestVehClass,
        priciestVehClass,
    } = props

    const priciestVehClassTranslation = getTranslationFromTransportType(priciestVehClass)
    const cheapestVehClassTranslation = getTranslationFromTransportType(cheapestVehClass)

    const {max: priciestPrice} = getMinMaxPriceForType(singleRoutes[priciestVehClass])
    const {min: cheapestPrice} = getMinMaxPriceForType(singleRoutes[cheapestVehClass])

    const title = useTranslation(
        `${multiModalTranslationKey}.how_many_trips.title`,
        {departure, destination}
    )

    const description = useTranslation(
        `${multiModalTranslationKey}.how_many_trips.desc1`,
        {
            departure,
            destination,
            totalNumberOfTrips,
            cheapestVehClass: cheapestVehClassTranslation,
            cheapestPrice,
            priciestVehClass: priciestVehClassTranslation,
            priciestPrice,
        }
    )

    return (
        <TitleAndContent
            title={title}
            content={description}
        />
    )
}

export default HowManyTripsContent